const validatorMixin = {

    data() {

        return {

            accountUser: {
                id: 0,
                username: '',
                email: '',
                first_name: '',
                last_name: '',
                role_name: '',
                document: '',
                phone: '',
                permissions: [],
                token: '',
            },
        };
    },

    mounted() {

        try{
            
            const user = localStorage.getItem('user');
            const extraData = JSON.parse(localStorage.getItem('extra_data'));
            this.accountUser = JSON.parse(user);
            this.accountUser.document = extraData.document;
            this.accountUser.phone = extraData.phone;
            this.accountUser.token = localStorage.getItem("token");

        } catch(ex){

            console.log(ex);
        }
    },

    methods: {

        validatePermission(permission) {
            
            return this.accountUser.role_name == 'Admin' || this.accountUser.permissions.some(p => p.codename == permission);
        },
    },

};

export default validatorMixin;
